export function setCutComments({ state, data }) {
  state.editor.cutComments = data
}
